import { render, staticRenderFns } from "./ApprovedText.vue?vue&type=template&id=8fb8ff7e&"
import script from "./ApprovedText.vue?vue&type=script&lang=js&"
export * from "./ApprovedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports